<template>
  <div id="settings-page" class="page-view teacher-settings d-flex align-items-center justify-content-center pt-5">
    <div class="container">

      <div class="row teacher-settings-details">
        <div class="col-4">
          <h5 v-if="!user.parent" class="mb-3"><b>LehrerIn</b></h5>
          <h3 class="first-teacher">{{ adminUser }}</h3>
          <p v-if="user.parent">Erziehungsberechtigter 1</p>
          <p v-else>Admin</p>
          <div v-if="secondUser">
            <h3 class="second-teacher">{{ secondUser }}</h3>
            <p v-if="user.parent">Erziehungsberechtigter 2</p>
            <p v-else>Sub-Admin</p>
          </div>
        </div>
      </div>

      <div class="row teacher-settings-actions">
        <div class="col-4">
          <div class="separator-dotted mb-3 mx-auto w-100"></div>

          <div class="settings-switch-container mb-3 clearfix">
            <h5 class="mb-0 d-inline-block">E-Mail Benachrichtigungen aktivieren</h5>
            <div v-show="loaded" class="switch-wrapper">
              <label class="switch-toggle btn-cursor">
                <input @click="setEmailNotifications" type="checkbox" v-model="accountDetails.email_notification">
                <span>
                  <span class="switch-off">OFF</span>
                  <span class="switch-on">ON</span>
                </span>
                <a class="btn"></a>
              </label>
             </div>
          </div>
          <div v-if="user.isParent()">
            <span class="mb-0 d-inline-block">Sprache für die Übersetzung wählen:</span>
            <select v-model="translateTarget" id="ddlTarget" class="col-4 float-right" @change="changeLanguage">
              <option v-for="language in languages" :value="language">{{ language.name }}</option>
            </select>
          </div>
          <a href="mailto:info@klassenpinnwand.at?subject=Feedback Hallo! Lehrer App" class="d-block teacher-settings-link btn-cursor">
            Wir freuen uns über Ihr Feedback
            <img :src="'./static/img/' + user.role +'/arrow_right_2.png'">
          </a>
          <a href="https://www.klassenpinnwand.at/support/datenschutz" target="_blank" class="d-block teacher-settings-link btn-cursor">
            Datenschutzerklärung
            <img :src="'./static/img/' + user.role +'/arrow_right_2.png'">
          </a>
          <a href="https://www.klassenpinnwand.at/support/impressum" target="_blank" class="d-block teacher-settings-link btn-cursor">
            Impressum
            <img :src="'./static/img/' + user.role +'/arrow_right_2.png'">
          </a>
          <a href="https://www.klassenpinnwand.at/support/edugroup" target="_blank" class="d-block teacher-settings-link btn-cursor">
            Über Edu Group
            <img :src="'./static/img/' + user.role +'/arrow_right_2.png'">
          </a>

          <div class="separator-dotted mt-4 mb-3 mx-auto w-100"></div>
        </div>
      </div>

      <!-- <div class="row teacher-settings-logout pb-2">
        <div class="col-4">
          <a @click="logout()" style="cursor: pointer;">Abmelden</a>
        </div>
      </div> -->

    </div>
  </div>
</template>

<script>
// Components
import Alert from '@/components/Helpers/Alert';
// API
import accountApi from '@/api/v1/account';
import pinboardApi from '@/api/v1/pinboard';
import messageApi from '@/api/v1/messages';
// mixins
import alert from '@/mixins/alert';

export default {
  components: { Alert },
  mixins: [alert],
  data() {
    return {
      user: this.$current_user,
      accountDetails: {},
      pinboard: {},
	  adminUser:'',
	  secondUser: '',
      loaded: false,
      languages: [],
      translateTarget: messageApi.translateTarget(),
    };
  },
  methods: {
    setEmailNotifications() {
      accountApi.enableEmailNotifications(!this.accountDetails.email_notification)
      .then(() => {
        this.alert.success = 'Email notifications changed!';
      }).catch((response) => {
        this.alert.error = response.errormessage;
      });
    },
    assignUsers() {
	
      if (this.pinboard) {
        for (let i = 0; i < this.pinboard.users.length; i += 1) {
          var userName = '';
		  if(this.pinboard.users[i].firstname !== null) {
			userName = this.pinboard.users[i].firstname;
		  }
		  if(this.pinboard.users[i].lastname !== null) {
			userName = userName + " " + this.pinboard.users[i].lastname;
		  }
		  
		  if(this.pinboard.users[i].admin || (!this.pinboard.users[i].teacher && this.pinboard.users[i].itemid === this.user.accessId)) {
			if(this.adminUser !== '') {
				// second admin user
				this.adminUser = this.adminUser + ', ' + userName;
			} else {
				// first admin user
				this.adminUser = userName;
			}
		  } else {
			if(this.secondUser !== '') {
				// second admin user
				this.secondUser = this.secondUser + ', ' + userName;
			} else {
				// first admin user
				this.secondUser = userName;
			}
		  }
		  
        }
      }
    },
    changeLanguage() {
      localStorage.setItem('translateTarget', JSON.stringify(this.translateTarget));
    },
    // logout() {
    //   accountApi.logout();
    // },
  },
  created() {
    accountApi.show((data) => {
      this.accountDetails = data.detailresponse;
      this.loaded = true;
    });
    pinboardApi.show((data) => {
      this.pinboard = data.detailresponse;
      this.assignUsers();
    }, this.user.child);
    if (this.user.isParent()) {
      messageApi.getLanguages((langs) => {
        this.languages = langs;
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Pages/Settings.vue